import React from 'react';
import AppSettingsContext from './context.js';
import {StarElement} from './templates/elements.js';

/*---------------------------------------------*/

class FormInput extends React.Component {
	constructor() {
		super();

		this.ref = null;
		this.getValue = this.getValue.bind(this);
	}

	getValue() {}
}

/*---------------------------------------------*/

class TextInput extends FormInput {
	constructor() {
		super();

		this.ref = React.createRef();
	}

	getValue() {
		return this.ref.current.value;
	}
	
	render() {
		let style = this.props.style;

		return <input style={style} type={this.props.type} name={this.props.name} ref={this.ref} />
	}
}

/*---------------------------------------------*/

class TextAreaInput extends FormInput {
	constructor() {
		super();

		this.ref = React.createRef();
	}

	getValue() {
		let value = this.ref.current.value;
		value = value.replace(/\r\n/g,'<br>').replace(/\n/g,'<br>')
		
		return value;
	}
	
	render() {
		let style = this.props.style;

		return <textarea style={style} type={this.props.type} name={this.props.name} rows={this.props.rows} ref={this.ref}></textarea>
	}
}

/*---------------------------------------------*/

class RatingInput extends FormInput {
	constructor() {
		super();

		this.handleMouseLeave = this.handleMouseLeave.bind(this);
		this.handleStarMouseEnter = this.handleStarMouseEnter.bind(this);
		
		this.state = {
			hoverIndex: 0,
			value: 0
		}
	}

	getValue() {
		return this.state.value;
	}

	handleMouseLeave() {
		this.setState({hoverIndex: 0});
	}

	handleStarMouseEnter(index) {
		this.setState({hoverIndex: index});
	}

	handleStarClick(index) {
		this.setState({value: index});
	}

	render() {
		let style = {
			whiteSpace: 'nowrap',
			fontSize: 0
		}

		let starProps = {
			size: 24,
			color: '#f5a623'
		}

		let stars = Array(5).fill(null).map((v,i) => (
			<span onMouseEnter={() => this.handleStarMouseEnter(i+1)} onClick={() => this.handleStarClick(i+1)} key={i}>
				<StarElement {...starProps} index={i} value={i < (this.state.hoverIndex ? this.state.hoverIndex : this.state.value)} />
			</span>
		))

		return (
			<div className="rating" style={style} onMouseLeave={this.handleMouseLeave} ref={this.container}>{stars}</div>
		)
	}
}

/*---------------------------------------------*/

class ImagePicker extends FormInput {
	constructor() {
		super();

		this.state = {
			value: null,
			loading: false
		}

		this.getValue = this.getValue.bind(this);
		this.handleUploadClick = this.handleUploadClick.bind(this);
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
	}

	getValue() {
		return this.state.value;
	}
	
	handleUploadClick() {
		window.uploadcare.openDialog(null, {
			crop: "200x200",
			imagesOnly: true

		}).done((file) => {
			this.setState({loading: true});
			file.promise().done((fileInfo) =>{
				window.inffuse.services.uploadcare.copy(fileInfo.cdnUrl,"S3-UploadCare")
					.then((data) => {
						let filename = data.filename.replace("s3://","https://s3.amazonaws.com/");
						this.setState({value: filename});
						setTimeout(() => this.setState({loading: false}), 1000);
					});
			});
		});
	}

	handleDeleteClick() {
		this.setState({value: null});
	}

	render() {
		let styles = {
			container: {
				background: '#f8f8f8',
				border: 'dashed 2px #c5c1f4',
				padding: '12px 15px'
			},
			imageContainer: {
				display: 'inline-block',
				position: 'relative',
				border: '1px solid #aaa',
				verticalAlign: 'middle',
				cursor: 'pointer',
				fontSize: 0
			},
			actions: {
				container: {
					display: 'inline-block',
					verticalAlign: 'middle',
					marginLeft: 16
				},
				left: {
					marginRight: 8,
					cursor: 'pointer'
				},
				right: {
					cursor: 'pointer'
				}
			},
			button: {
				fontSize: 16,
				lineHeight: 1.5,
				textAlign: 'center',
				color: '#4a4a4a',
				borderRadius: 2,
				boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.25)',
				border: '1px solid #4a4a4a',
				background: '#ffffff',
				whiteSpace: 'nowrap',
				display: 'block',
    			margin: 'auto'
			}
		}

		let imageUrl = this.state.value || 'img/user.svg';

		// let uploadcareProps = {
		// 	publicKey: "9bb13f4dcc91a88fe4a9",
		// 	tabs: 'file camera url facebook gphotos dropbox instagram',
		// 	effects: 'crop,rotate',
		// 	imageShrink: '500x500',
		// 	imagesOnly: true,
		// 	previewStep: true,
		// }

		let actions = this.state.value ? 
			[
				<img src='img/form/change.svg' style={styles.actions.left} onClick={this.handleUploadClick} alt="Change" key="change" />,
				<img src='img/form/delete.svg' style={styles.actions.right} onClick={this.handleDeleteClick} alt="Delete" key="delete" />
			] :
			[
				<img src='img/form/upload.svg' style={styles.actions.left} onClick={this.handleUploadClick} alt="Change" key="change" />
			];
			

		return (
			<div style={styles.container}>
				<div style={styles.imageContainer} onClick={this.handleUploadClick} className={this.state.loading ? 'loading' : ''}>
					<img src={imageUrl} width="56" alt="Preview" />
				</div>
				<div style={styles.actions.container}>
					{actions}
				</div>
			</div>
		)
	}
}

/*---------------------------------------------*/

class FormField extends React.Component {
	constructor() {
		super();

		this.inputRef = React.createRef();
		this.getValue = this.getValue.bind(this);
	}

	getValue() {
		return this.inputRef && this.inputRef.current.getValue && this.inputRef.current.getValue();
	}

	render() {
		let type = this.props.type;
		let key = this.props.dbKey;
		let label = this.props.label;

		let styles = {
			container: {
				marginBottom: 24
			},
			label: {
				display: 'block',
				fontFamily: 'Roboto',
				fontSize: 14,
				lineHeight: 1.5,
				marginBottom: 2,
				color: '#000'
			},
			input: {
				width: '100%',
				padding: '11px 14px 8px 11px',
				boxSizing: 'border-box',
				background: '#f8f8f8',
				border: 'none',
				borderBottom: 'solid 1px #c5c1f4'
			}
		}

		let input = (() => {
			switch (type) {
				case 'text':
					return <TextInput style={styles.input} type="text" name={key} ref={this.inputRef} />

				case 'email':
					return <TextInput style={styles.input} type="email" name={key} ref={this.inputRef} />

				case 'url':
					return <TextInput style={styles.input} type="url" name={key} ref={this.inputRef} />

				case 'textarea':
					return <TextAreaInput style={styles.input} name={key} rows="5" ref={this.inputRef} />
				
				case 'rating':
					return <RatingInput ref={this.inputRef}></RatingInput>
				
				case 'image':
					return <ImagePicker ref={this.inputRef} />
				
				default:
					return `Unrecognized input type "${type}"`;
			}
		})();

		
		return (
			<div style={styles.container}>
				<label style={styles.label}>{label}</label>
				{input}
			</div>
		)
	}
}

/*---------------------------------------------*/

export default class TestimonialForm extends React.Component {
	static contextType = AppSettingsContext;

	constructor() {
		super();

		this.params = null;

		this.state = {
			loading: false,
			submitted: false
		};

		this.init = this.init.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		document.documentElement.className += " form";
	}

	handleSubmit(e) {
		e.preventDefault();

		window.inffuse.site.meta((siteInfo) => {
			let testimonial = {
				id: Math.round(Math.random()*999999),
				date: 1*(new Date()),
				page_url: siteInfo && siteInfo.url,
				page_title: siteInfo && siteInfo.pageTitle,
				site_title: siteInfo && siteInfo.siteTitle,
			};

			this.params.forEach((param) => {
				testimonial[param.dbKey] = param.ref.current.getValue();
			});

			this.setState({loading: true});
			window.inffuse.project.getDataStore('private').append('submissions',testimonial)
				.then(() => {
					window.inffuse.services.email.send("praise.submitted",{testimonial: testimonial});
					this.setState({
						loading: false,
						submitted: true
					});
				});
		});
		
		return false;
	}

	static getParams(context) {
		let params = [
			{
				dbKey: 'author_name',
				type: 'text',
				required: true
			},
			{
				dbKey: 'author_email',
				type: 'email',
				required: true
			},
			{
				dbKey: 'job_title',
				type: 'text'
			},
			{
				dbKey: 'company_name',
				type: 'text',
				displayKey: 'company'
			},
			{
				dbKey: 'company_url',
				type: 'url',
				displayKey: 'company'
			},
			{
				dbKey: 'text',
				type: 'textarea',
				required: true
			},
			{
				dbKey: 'author_image',
				type: 'image'
			},
			{
				dbKey: 'rating',
				type: 'rating'
			}
		];

		return params.filter((p) => (p.required || context.get(`form.fields.${p.displayKey || p.dbKey}.enabled`)));
	}

	init() {
		this.params = TestimonialForm.getParams(this.context);
		this.params.forEach((param) => {
			let key = `form.fields.${param.dbKey}.label`;
			param.label = this.context.get(key, this.context.default(key));

			param.ref = param.ref || React.createRef();
		});
	}

	renderForm() {
		let styles = {
			container: {
				maxWidth: 800,
				margin: 'auto'
			},
			title: {
				margin: 0,
				paddingBottom: 8,
				textAlign: 'center',
				borderBottom: '1px solid #19126a',
				fontFamily: 'Helvetica',
				fontWeight: 300,
				lineHeight: 1.75,
				color: '#19126a'
			},
			form: {
				marginTop: 24,
				border: 'none'
			},
			imagePicker: {
			},
			inputs: {
				gridColumn: 3
			},
			button: {
				width: '100%',
				boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.25)',
				backgroundColor: '#19126a',
				borderRadius: 2,
				border: 'none',
				fontSize: 18,
				lineHeight: 1.5,
				textAlign: 'center',
				color: '#fbfbfd',
				padding: 12
			},
			param: {}
		}
	
		let inputs = this.params.map((param) => <FormField {...param} ref={param.ref} key={param.dbKey} />)

		let titleText = this.context.get('form.title.text') || this.context.default('form.title.text');
		let buttonText = this.context.get('form.button.text') || 'Submit';

		return (
			<div className="praise__form" style={styles.container}>
				<h2 className="praise__form__title" style={styles.title}>{titleText}</h2>
				<form style={styles.form} onSubmit={this.handleSubmit}>
					<div style={styles.inputs}>
						{inputs}
						<button style={styles.button}>{buttonText}</button>
					</div>					
				</form>
			</div>
		)
	}

	closeForm() {
		window.inffuse.utils.closePopup();
	}

	renderResponse() {
		let styles = {
			container: {
				display: this.state.submitted ? 'block' : 'none',
				background: 'white',
				position: 'absolute',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
			},
			box: {
				position: 'relative',
				top: '50%',
				margin: '0 80px',
				padding: '64px 0',
				textAlign: 'center',
				transform: 'translateY(-50%)'
			},
			text: {
				fontSize: 28,
				lineHeight: 1.5,
				color: '#1a1a1a',
				maxWidth: '15em',
				margin: '32px auto auto auto'
			},
			image: {
				width: 80
			},
			close: {
				padding: 0,
				border: 'none',
				background: 'transparent',
				display: 'inline-block',
				marginTop: 60,
				fontSize: 16,
				fontWeight: 300,
				lineHeight: 1.25,
				color: '#737373',
				textDecoration: 'underline',
				cursor: 'pointer'
			}
		}

		let responseText = this.context.get('form.confirmation.text','Thank you for sharing your experience!');
		let closeText = "Close";

		return (
			<div style={styles.container}>
				<div style={styles.box}>
					<img src="img/form/success.png" style={styles.image} alt="Success" />
					<div style={styles.text}>{responseText}</div>
					<button style={styles.close} type="button" onClick={this.closeForm}>{closeText}</button>
				</div>
			</div>
		)
	}

	render() {
		if (!this.context.isInitialized())
			return null;

		if (!this.params)
			this.init();

		let styles = {
			container: {
				overflow: 'auto'
			}
		}

		let content = this.state.submitted ? this.renderResponse() : this.renderForm();
		return (
			<div style={styles.container} className={this.state.loading ? 'loading fullscreen' : ''}>
				{content}
			</div>
		)
	}
}

/*---------------------------------------------*/
